import { AWSUploader } from './uploader-aws';
import { UploaderCos } from './uploader-cos';
import { isBuildIn } from './util';

// export const fileUploader = isBuildIn() ? new AWSUploader() : new UploaderAliyun();
export const fileUploader = isBuildIn() ? new AWSUploader() : new UploaderCos();
